module.exports = "<span data-ng-message=required>*Required</span> <span data-ng-message=uniquePmDocumentName>*A Document already exists with that name</span> ";